export const CAMPAIGN_TABS = {
    ACTIVE: {
        key: "ACTIVE",
        value: "Active"
    },
    INACTIVE: {
        key: "INACTIVE",
        value: "Inactive"
    },
    DRAFT: {
        key: "DRAFT",
        value: "Draft"
    },
}